import { FunctionComponent, ReactElement } from "react";

import { useTurnOffDelay } from "@multiweb/reactUtils/hooks";

export type DelayedUnmountProps = {
    /** Zpozdění odpojení potomka z DOM */
    delayMs: number;
    /** Příznak, zda má být potomek zapojený do DOM */
    mounted: boolean;
    /** Potomek */
    children: ReactElement;
};

/**
 * Komponenta slouží pro zpoždění odpojení komponenty z DOM.
 */
export const DelayedUnmount: FunctionComponent<DelayedUnmountProps> = ({
    delayMs,
    mounted,
    children,
}) => {
    const delayedMount = useTurnOffDelay(mounted, delayMs);

    return delayedMount ? children : null;
};
